import * as actionTypes from '../constants/index';
const spin = (state = { status: false }, action) => {
    switch (action.type) {
        case actionTypes.SPIN_HIDE:
            return Object.assign({}, state, { status: false });
        case actionTypes.SPIN_SHOW:
            return Object.assign({}, state, { status: true });
        default:
            return state;
    }
};
export { spin };



// WEBPACK FOOTER //
// ./src/reducers/spin.js